import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=63caa28b&"
import script from "./basic.vue?vue&type=script&lang=ts&"
export * from "./basic.vue?vue&type=script&lang=ts&"
import style0 from "./basic.vue?vue&type=style&index=0&id=63caa28b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadWhenVisible: require('/usr/src/app/components/storyblok/LoadWhenVisible.vue').default})
